import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import useMobileLayout from '@/hooks/use-mobile-layout';
import useChatWidgetEffectiveOpen from '../../hooks/use-chat-widget-effective-open';
import useChatWidgetEnabled from '../../hooks/use-chat-widget-enabled';
import useChatWidgetLayout from '../../hooks/use-chat-widget-layout';
import useChatWidgetLockedFullscreen from '../../hooks/use-chat-widget-locked-fullscreen';
import useChatWidgetSidebarWidth from '../../hooks/use-chat-widget-sidebar-width';
import useDocumentsPanelOpen from '../../hooks/use-documents-panel-open';
import useInvestigationDock from '../../hooks/use-investigation-dock';
import ChatWidgetSidebarSplitter from './chat-widget-sidebar-splitter';
import { useChatWidgetSlot } from './chat-widget-slot-context';
type ChatWidgetSlotProps = {
  // Live width during a splitter drag; the layout row owns the var (see use-chat-widget-slot-width).
  onResizeWidth: (px: number) => void;
  onResizingChange: (resizing: boolean) => void;
  // Page-hosted slot (e.g. the agent builder): registers on the override channel,
  // which wins over the layout slot.
  override?: boolean;
};

// Docked chat column beside the main card: consumes `--chat-widget-width`
// (snapping, so the morph measures the final rect), registers the portal target,
// and hosts the resize splitter. The page reflow is the content card's transition.
const ChatWidgetSlot = t0 => {
  const $ = _c(11);
  const {
    onResizeWidth,
    onResizingChange,
    override
  } = t0;
  const enabled = useChatWidgetEnabled();
  const isMobile = useMobileLayout();
  const effectiveOpen = useChatWidgetEffectiveOpen();
  const {
    isSidebar
  } = useChatWidgetLayout();
  const {
    width,
    setWidth
  } = useChatWidgetSidebarWidth();
  const {
    setSlotEl,
    setOverrideSlotEl,
    hasOverride
  } = useChatWidgetSlot();
  const {
    isOpen: documentsPanelOpen
  } = useDocumentsPanelOpen();
  const lockedFullscreen = useChatWidgetLockedFullscreen();
  const lockedSidebar = useInvestigationDock();
  const active = enabled && !isMobile && effectiveOpen && (isSidebar || lockedSidebar) && !lockedFullscreen && (override || !hasOverride);
  const canResize = active && !documentsPanelOpen;
  const containerRef = useRef(null);
  if (!active) {
    return null;
  }
  let t1;
  if ($[0] !== canResize || $[1] !== onResizeWidth || $[2] !== onResizingChange || $[3] !== setWidth || $[4] !== width) {
    t1 = canResize && <div className="absolute inset-y-0 -left-1 z-10 flex items-stretch"><ChatWidgetSidebarSplitter containerRef={containerRef} width={width} onDragStart={() => onResizingChange(true)} onDrag={onResizeWidth} onDragEnd={next => {
        onResizingChange(false);
        setWidth(next);
      }} /></div>;
    $[0] = canResize;
    $[1] = onResizeWidth;
    $[2] = onResizingChange;
    $[3] = setWidth;
    $[4] = width;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = override ? setOverrideSlotEl : setSlotEl;
  let t3;
  if ($[6] !== t2) {
    t3 = <div ref={t2} className="h-full w-full py-2 pr-2" />;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <div ref={containerRef} className="relative h-full shrink-0 overflow-hidden w-(--chat-widget-width,0px)">{t1}{t3}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default ChatWidgetSlot;